const REQUEST_STATUSES = {
  true: 'فعال',
  false: 'در حال غیرفعال',
};

const columns = (onClickDetail = () => {}, onChangeStatus = () => {}) => [
  {
    title: 'وضعیت',
    field: 'active',
    align: 'center',
    filtering: false,
    sorting: false,
    render: (rd) => REQUEST_STATUSES?.[rd?.active] ?? '-',
  },
  {
    title: 'آدرس بازگشت',
    field: 'url',
    align: 'right',
    filtering: false,
    sorting: false,
    cellStyle: {
      width: '90%',
    },
  },
];

const columnsId = {};

const orderingIndexes = [];

const generateData = (rows, query) => {
  const newData = rows.map((row, key) => {
    return {
      num: key + 1,
      url: row['url'],
      active: row['active'],
    };
  });

  return newData;
};

export { columns, columnsId, generateData, orderingIndexes };
